import Request from ".";
import { ApiRoutes } from "../constants";

export const insertCategoryApi = async (data) => {
  try {
    const res = await Request.post(ApiRoutes.INSERT_TEMPLATE_CATEGORY, data);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getCategoryApi = async () => {
  try {
    const res = await Request.get(ApiRoutes.GET_TEMPLATE_CATEGORY);
    return res;
  } catch (error) {
    throw error;
  }
};

export const updateCategoryApi = async (data) => {
  try {
    const res = await Request.post(ApiRoutes.UPDATE_TEMPLATE_CATEGORY, data);
    return res;
  } catch (error) {
    throw error;
  }
};

export const deleteCategoryApi = async (data) => {
  try {
    const res = await Request.delete(ApiRoutes.DELETE_TEMPLATE_CATEGORY, {
      data,
    });
    return res;
  } catch (error) {
    throw error;
  }
};

